import { cva, type VariantProps } from "class-variance-authority";

export const candidateLogoVariants = cva(
  "shrink-0 overflow-hidden border border-border",
  {
    variants: {
      size: {
        sm: "size-4 rounded border-[0.9px]",
        md: "size-4.5 rounded-sm",
        lg: "size-[42px] rounded-md",
      },
    },
    defaultVariants: { size: "md" },
  },
);

export type CandidateLogoSize = NonNullable<
  VariantProps<typeof candidateLogoVariants>["size"]
>;

const URL_SIZE_BY_VARIANT: Record<CandidateLogoSize, number> = {
  sm: 32,
  md: 64,
  lg: 256,
};

export function logoUrlSize(size: CandidateLogoSize | undefined): number {
  return URL_SIZE_BY_VARIANT[size ?? "md"];
}
